import auth from './auth';
import { LoginInputType } from '../../infra/startup/types';
import { APIv2Type } from '@clientos/types/dist';

export default async function initializeShellInterfaceV2(
  loginInput: LoginInputType
): Promise<APIv2Type> {
  const authProvider = auth(loginInput);

  return {
    authProvider
  };
}
